import enviro from 'enviro';

export enum ENV {
  PROD = 'PROD',
  QA = 'QA',
}

export const CURRENT_ENV = enviro.isQa() ? ENV.QA : ENV.PROD;
